import { Component, HostBinding, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { LoggingService } from "src/app/core/services/logging.service";
import { PromptTemplatesDismissType } from "src/app/features/design/models/prompt-templates-dismiss-type";
import { EventsService } from "src/app/features/events/services/events.service";
import { EventNavigationService } from "src/app/features/events/shared/services/event-navigation.service";

@Component({
  selector: "app-showroom-show-templates-button",
  templateUrl: "./showroom-show-templates-button.component.html",
  styleUrls: ["./showroom-show-templates-button.component.scss"],
  standalone: false,
})
export class ShowroomShowTemplatesButtonComponent implements OnInit {
  @HostBinding("style.display") display: string = "none";

  constructor(
    private _eventsService: EventsService,
    private _eventNavigationService: EventNavigationService,
    private _matDialog: MatDialog,
    private _route: ActivatedRoute,
    private _loggingService: LoggingService,
  ) {}

  ngOnInit(): void {
    if (this._eventsService.getCurrentEvent()?.hasEventTemplates()) {
      this.display = "block";
    }
  }

  onSeeTemplatesClick(): void {
    this._loggingService.logWorkflow(
      "Showroom See Templates Click",
      "ShowroomShowTemplatesButtonComponent.onSeeTemplatesClick",
      "Showrooms",
      "SeeTemplatesClick",
      "ShowroomShowTemplatesButton",
    );

    this._eventNavigationService.navigateTo3D(
      this._matDialog,
      this._route,
      {
        promptTemplates: true,
        ignoreDesigns: true,
        navigateIfTemplateSkip: false,
        dismissType: PromptTemplatesDismissType.Close,
        allowTemplateEdit: true,
        bypassSitePreferences: true,
      },
      "VenueSeeTemplates",
    );
  }
}
